import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShareIos1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M5 4a4 4 0 0 0-4 4v1.5h4q.077 0 .15.011a3.024 3.024 0 0 1 4.392-1.617L12 9.34l2.458-1.446A3.024 3.024 0 0 1 18.85 9.51q.073-.01.15-.011h4V8a4 4 0 0 0-4-4zM23 11.5h-4q-.076 0-.15-.011a3.024 3.024 0 0 1-4.392 1.618l-.052-.031.488.977a1 1 0 1 1-1.788.894L12 12.737l-1.106 2.21a1 1 0 1 1-1.788-.894l.488-.978-.052.031A3.024 3.024 0 0 1 5.15 11.49 1 1 0 0 1 5 11.5H1V16a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4z'
    />
    <path
      fill={props.color}
      d='M7.32 9.743a1.02 1.02 0 0 1 1.208-.125l1.5.882-1.5.883a1.024 1.024 0 0 1-1.208-1.64M15.472 11.383l-1.5-.883 1.5-.882a1.024 1.024 0 1 1 0 1.765'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShareIos1)
export default ForwardRef
